import { PaginationBar } from "@roc/ui";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({

  pagination: {
    justifyContent: 'flex-end',
    border: 'none',
    borderRight: '1px solid #ddd',
  },
}));

export const CompPagination = observer(() => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compResponse } = compToolStore;
  const classes = useStyles();

  const page = compResponse.page;
  const perPage = compResponse.per_page;
  const start = ((page - 1) * perPage) + 1;

  return (
    <PaginationBar
      start={start}
      pageSize={perPage}
      totalRecords={compResponse.number_of_properties}
      pageNumber={compResponse.page}
      totalPages={compResponse.pages}
      onChange={(_, value) => { compToolStore.fetchPropertiesWithPagination(value) }}
      className={classes.pagination}
    />
  );
}
);